module.exports = __webpack_public_path__ + "img/add-videos-below.338e2ad8.png";